import { render } from "./ProductDiagnosisIcon.vue?vue&type=template&id=0074710b"
import script from "./ProductDiagnosisIcon.vue?vue&type=script&lang=js"
export * from "./ProductDiagnosisIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ProductDiagnosisIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0074710b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0074710b', __exports__)) {
    api.reload('0074710b', __exports__)
  }
  
  module.hot.accept("./ProductDiagnosisIcon.vue?vue&type=template&id=0074710b", () => {
    api.rerender('0074710b', render)
  })

}


export default __exports__